import { useState } from 'react';
import Meeting from './meeting';
import Timer from '../features/timer';

function ContactCard(props) {
    let contact = props.contact
    const view = props.view
    const setView = props.setView
    const { email, handle , first_name , last_name , phone }  =  contact

   
    const cur_user = window.localStorage.getItem('cur_user')

   
    function contactClick(e){
        let id = e.target.value
        console.log("clicking")
        // const object = array.find(obj => obj.id === 3);
        // window.localStorage.setItem('event',JSON.stringify())
        console.log(e)
        // props.setView(<Meeting meeting={meeting} />)
        // props.setView(<Meeting meeting={meeting} />)
        // window.location.href = `/event?id=${id}`
        // console.log(meeting_id)
        
    }   
    if (props.view ==="contacts"){
        return(
          <button
          // id="leave-btn"
          id="contact-card-sml"
          className="contact-card-sml blink-slower"
        //   onClick={() =>window.location.href = `/contacts`}
          >
              <span>
                 <h6>{email}</h6> 
                  <img src="/images/id-card.svg" alt="contacts card" />
              </span>
      </button>
        )
    }else{

        return (
        <section id="meeting-block">   
        <div className="nda-link blink-faster">
            <div>
                {/* <a href='/ndaer'> */}
                    <img src="/images/money-bill-1-wave-solid-insert_exp.svg" />
                {/* </a> */}
                pay
           </div>     
        </div>
            <div className="meeting-component color-grad-blue"
                >
                {/* ========= [Heeader]  =========*/}
                <div className="meeting-card-header">
                    <span className="meeting-title"> 
                    <div id="share-icon">
                        <img src ='/images/share-nodes-regular.svg' alt="Share event icon"></img>
                    </div>
                        <span id="meeting-title"><b>"{email}"</b></span></span>
                    
                    <h6>{first_name}</h6>
                    <span>
                       {/* {!showAdmin&&(
                        <span id="admin-tag"  className='blink' 
                            onClick={() => setShowAdmin(true)}>
                            admin &#9663;
                        </span> )}
                        {showAdmin&&( <span className="admin_info blink"
                        onClick={() => setShowAdmin(false)}
                        >{event_admin}&#9667;</span>)}  */}
                    </span>
                </div>
                {/* ========= [Top] =========*/}
                <div className="meeting-comp-top">
                   <div className="meeting-comp-top-left">
                       {/* <span className={event_type}>{event_type}</span> */}
                    </div>
                <div>
    
                    </div>
                    
                   <div className="meeting-comp-top-right">
                   {/* <span className={status_class}><span id="meeting_status"> &#x2022; {event_status} </span></span> */}
                    </div>
                </div>
    
                {/* ========= [Bottom] =========*/}
                <div className="meeting-comp-bottom">
                      {/* ========= [Bottom Center] =========*/}
                      {/* <div onClick={(e)=>{eventClick(e)}}className="meeting-comp-btm-center color-grad-blue-text "
                      value ={event_id} 
                      >
                        enter
                     </div> */}
                    {/* ========= [Bottom Left]  =========*/}
                   <div className="meeting-comp-btm-left">
                        {/* <span className = "meeting-attendees" id="meeting-attendees">
                            attendees: {event_attendees.length}
                        </span> */}
                    </div>
                  
                    {/* ========= [Bottom Right] =========*/}
                   <div className="meeting-comp-btm-right">  
                   {/* <span>
                       {!showDuration&&(
                        <span className={time_class} id="time_handling" 
                            onClick={() => 
                            setShowDuration(true)}>
                            &#9663; {event_time_handling.type}-time 
                        </span> )}
                        {showDuration&&( 
                            <span className= {time_class} id="time_handling"
                            onClick={() => setShowDuration(false)}
                            >&#9657; {time}</span>)} 
                    </span>  */}
                    </div>
                </div>
    
            </div>
        </section>
    );
    }


}
export default ContactCard;